import React from 'react';
import './PromoVideo.css';

export const PromoVideo = () => {
  // REPLACE with your actual YouTube ID (e.g., from a Short or vertical video)
  const videoId = "HsOzqu9_NqM"; 

  return (
    <section className="promo-video-section">
      {/* Decorative background circle for the 'Wow' effect */}
      <div className="promo-bg-glow"></div>

      <div className="container promo-container">
        
        <div className="promo-text">
          <h2 className="section-title light-text">See Qinto in Action</h2>
          <p className="section-subtitle light-text">
            Watch a quick demo of how easy it is to list an item using our AI camera.
          </p>
        </div>

        {/* The Vertical "Phone" Video Container */}
        <div className="phone-video-frame">
          <div className="video-responsive-vertical">
            <iframe 
              src={`https://www.youtube.com/embed/${videoId}?rel=0&modestbranding=1&loop=1&playlist=${videoId}`} 
              title="Qinto App Demo" 
              frameBorder="0" 
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" 
              allowFullScreen
            ></iframe>
          </div>
        </div>

      </div>
    </section>
  );
};